import { gql } from '@apollo/client';

const OrderInfoPublic = gql`
  fragment OrderInfoPublic on Order {
    id
    cartTransactionId
    subtotal
    state
    discountAmount
    taxAmount
    taxQuoteId
    shippingAmount
    total
    deliveryMethod
    currency
    hexCode
    courtesyOrder
    shippingAddress
    billingAddress
    createdAt
    productionOrders {
      id
      productionOrderItems {
        id
        trackingNumber
        shippingCarrier {
          id
          name
        }
      }
    }
    orderItems {
      id
      name
      price
      discountAmount
      taxAmount
      shippingAmount
      total
      quantity
      patientId
      patient {
        id
        firstName
        lastName
        arches
        scanReady
      }
      productId
      product {
        id
        featuredImage
        description
        arches
        medicalCode
        medicalDescription
        productFeatures {
          id
          text
        }
      }
    }
  }
`;

export default OrderInfoPublic;
